const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AddAppointmentToCalendar/AddAppointmentToCalendar.tsx';
import { useIntl } from 'react-intl';
import textMap from './translations';
import React from 'react';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { AppointmentObject } from '@cistec/common_web/defs/notReallyKisim';
import _ from 'lodash';
import AddToCalendarComponent from 'App/components/AppointementList/AddToCalendarComponent/AddToCalendarComponent';
import { convertStructuredAppointmentToAppointmentObject } from '@cistec/common_web/utils/kisim';
import { getAppointmentObjectTitle } from 'App/utils/appointment';
import { getPatAppSettings } from 'App/utils/generalUtils';

interface IAddAppointmentToCalendarProps {
    appointment?: StructuredAppointment;
    appointmentObject?: AppointmentObject;
    inputProps?: any;
}

export const AddAppointmentToCalendar = (props: IAddAppointmentToCalendarProps) => {
    const { formatMessage } = useIntl();
    const settings = getPatAppSettings();
    const { appointment } = props;

    const appointmentObject =
        props.appointmentObject ||
        (appointment ? convertStructuredAppointmentToAppointmentObject(appointment, formatMessage) : null);

    if (!appointmentObject) return null;

    const getRessourcenStandortString = (appointmentObject: AppointmentObject): string =>
        _.compact([appointmentObject.ressourcenStandort?.Standort, appointmentObject.ressourcenStandort?.Adresse]).join(
            ' '
        );

    const title =
        getAppointmentObjectTitle(appointmentObject, formatMessage, appointmentObject.patientByEmail || '') ||
        formatMessage(textMap.appointment);

    const location = _.compact([settings.hospitalLongName, getRessourcenStandortString(appointmentObject)]).join(' ');

    return (
        <AddToCalendarComponent
            title={title}
            responsiblePerson={appointmentObject.responsiblePerson || appointmentObject.resname}
            startDate={appointmentObject.startDat}
            endDate={appointmentObject.stopDat}
            location={location}
            inputProps={props.inputProps}
            options={['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Outlook', 'Yahoo']}
        />
    );
};
